



























































import { Vue, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { IItemParams } from "@/models/itemParams";
import { stringUtil } from "@/models/stringUtil.ts";
import { messager } from "@/models/messager.ts";

@Component
export default class ConfigurationItem extends Vue {
  @Prop({ type: Object, required: true }) params!: IItemParams;
  @Prop({ type: Boolean, required: true }) wasDisabledClick!: boolean;

  private readonly offset: number =
    this.$store.getters.configuration.tiny === "true" ? -1 : -1;
  private readonly previewSize: number =
    this.$store.getters.configuration.tiny === "true" ? 250 : 300;
  private readonly avatarSize: number =
    this.$store.getters.configuration.tiny === "true" ? 55 : 70;

  private openGroup = stringUtil.generateUUID();

  private get mobile(): boolean {
    return (
      (this as any).$vuetify.breakpoint.name === "xs" ||
      (this as any).$vuetify.breakpoint.name === "sm"
    );
  }

  @Emit("onItemSelected")
  private click() {
    if (this.$store.getters.scene.tasks > 0) {
      return;
    }
    if (this.params.isDisabled) {
      if (this.$store.getters.scene.previousItemClicked === this.params) {
        this.params.callback();
      } else {
        this.$store.commit("setPreviousItemClicked", this.params);
        if (this.mobile) {
          const message = `${this.$t("unifyWoodColorsSplitted_0")} 
        ${this.$t("unifyWoodColorsSplitted_1")} 
        ${this.$t("unifyWoodColorsSplitted_2")}`;
          messager.info(message);
        }
      }
      return;
    }
    this.$store.commit("setPreviousItemClicked", this.params);
    this.params.callback();
  }

  private onDisabledClick() {
    this.$emit("onDisabledClick");
    const text = this.$t("woodenElementsDisabled").toString();
    messager.info(text);
  }

  private getClass(): string {
    let result = "creative-configuration-item-clickable";
    if (this.params.isSelected)
      result += " creative-configuration-item-selected";
    if (this.$store.getters.scene.tasks)
      result += " creative-configuration-item-disabled";
    // if (this.params.isDisabled)
    //   result += " creative-configuration-item-disabled creative-configuration-item-disabled-color";
    return result;
  }

  private getGradient(): string {
    return "";
    // if (!this.params.isDisabled) {
    //   return "";
    // }
    // return "to top right, rgba(255,255,255,.50), rgba(255,255,255,.50)";
  }

  private createUrl(url: string): string {
    return stringUtil.createDownloadUrl(url);
  }

  private createMagnificationUrl(url: string): string {
    return stringUtil.toMagnificationUrl(url);
  }

  @Emit("onMouseOver")
  private onMouseOver() {
    return this.params;
  }

  @Emit("onMouseLeave")
  private onMouseLeave() {
    return this.params;
  }
}
